import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import HelmetWrapper from "../../../HelmetWrapper";
import { selectUser } from "../../auth/auth.selector";
import GlobalGymFilterAndHeading from "../GlobalGymFilterAndHeading";
import PTFlowStats from "./PTFlowStats";
import PTFlowTrainerInfoStats from "./PTFlowTrainerInfoStats";
import PTRevenueInfoStats from "./PTRevenueInfoStats";
import PTTrainerPerformance from "./PTTrainerPerformance";
import {
  convertStraight,
  currentMonthCurrentDate,
  currentMonthStartDate,
} from "../../common-data/Converts";
import { isManagerRole as checkIsManagerRole } from "../../common-data/Conversions";

const PTFlow = () => {
  const authData = useSelector(selectUser);
  const userInfoData = authData || {};

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    startDate: currentMonthStartDate,
    endDate: currentMonthCurrentDate,
    selectedDates: `${convertStraight(
      currentMonthStartDate
    )} - ${convertStraight(currentMonthCurrentDate)}`,
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    gym_id: allFilters.selectedGym?.value || "",
    date_from: allFilters.startDate || "",
    date_to: allFilters.endDate || "",
  };
  const [filters, setFilters] = useState(iniFilters);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id: allFilters.selectedGym?.value || "",
      date_from: allFilters.startDate || "",
      date_to: allFilters.endDate || "",
    }));
  }, [allFilters.selectedGym, allFilters.startDate, allFilters.endDate]);

  return (
    <HelmetWrapper title="WTF: PT Flow System">
      <Container fluid className="px-50px pt-flow-new">
        <Row>
          <Col>
            <GlobalGymFilterAndHeading
              decryptedText={userInfoData}
              selectedGym={allFilters.selectedGym}
              setSelectedGym={(value) =>
                setAllFilters((prevs) => ({
                  ...prevs,
                  selectedGym: value,
                }))
              }
              startAndEndDate={allFilters}
              setStartAndEndDate={setAllFilters}
              iniAllFilter={iniAllFilter}
              isPageHeadingHide={true}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <PTRevenueInfoStats
              userInfoData={userInfoData}
              prevAllFilters={allFilters}
              prevFilters={filters}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <PTFlowStats
              userInfoData={userInfoData}
              prevAllFilters={allFilters}
              prevFilters={filters}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <PTFlowTrainerInfoStats
              userInfoData={userInfoData}
              prevAllFilters={allFilters}
              prevFilters={filters}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <PTTrainerPerformance
              userInfoData={userInfoData}
              prevAllFilters={allFilters}
              prevFilters={filters}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default PTFlow;
